var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.7546C8.25 19.5831 7.57843 20.2546 6.75 20.2546C5.92157 20.2546 5.25 19.5831 5.25 18.7546M8.25 18.7546C8.25 17.9262 7.57843 17.2546 6.75 17.2546C5.92157 17.2546 5.25 17.9262 5.25 18.7546M8.25 18.7546H14.25M5.25 18.7546H3.375C2.75368 18.7546 2.25 18.251 2.25 17.6296V14.2551M19.5 18.7546C19.5 19.5831 18.8284 20.2546 18 20.2546C17.1716 20.2546 16.5 19.5831 16.5 18.7546M19.5 18.7546C19.5 17.9262 18.8284 17.2546 18 17.2546C17.1716 17.2546 16.5 17.9262 16.5 18.7546M19.5 18.7546L20.625 18.7546C21.2463 18.7546 21.7537 18.2503 21.7154 17.6302C21.5054 14.2226 20.3473 11.0715 18.5016 8.43748C18.1394 7.92055 17.5529 7.61238 16.9227 7.57779H14.25M16.5 18.7546H14.25M14.25 7.57779V6.61943C14.25 6.05194 13.8275 5.57185 13.263 5.51327C11.6153 5.34228 9.94291 5.25464 8.25 5.25464C6.55709 5.25464 4.88466 5.34228 3.23698 5.51327C2.67252 5.57185 2.25 6.05194 2.25 6.61943V14.2551M14.25 7.57779V14.2551M14.25 18.7546V14.2551M14.25 14.2551H2.25",
    stroke: "#30776b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.43b83a3109d7a5e915a40d20db3fa275.svg";
export { ForwardRef as ReactComponent };